<div
  *ngIf="showsToast"
  class="toast"
  [class.warning]="type === ToastType.WARNING"
  [class.error]="type === ToastType.ERROR"
  [class.success]="type === ToastType.SUCCESS"
>
  <div>
    {{ message }}
  </div>

  <!--button-->
  <div class="close-btn" (click)="showsToast = !showsToast">
    <small> Dismiss </small>
  </div>
</div>
